import { selectAllHandler } from '../../ess-tgs-tes-mc/select_box_logic/selectAllHandler';
import { selectMachineHandler } from '../../ess-tgs-tes-mc/select_box_logic/selectMachineHandler';
import { selectAllIndicatorDispatcherHandler } from './selectAllIndicatorDispatcherHandler';
import { selectLocationIndicatorDispatcherHandler } from './selectLocationIndicatorDispatcherHandler';
import { selectMachineIndicatorDispatcherHandler } from './selectMachineIndicatorDispatcherHandler';
import { selectSettingsLocationHandler } from './selectSettingsLocationHandler';
import { selectSettingsMachineHandler } from './selectSettingsMachineHandler';
import { selectSettingsSpecificLocationHandler } from './selectSettingsSpecificLocationHandler';
import { selectSpecificLocationIndicatorDispatcherHandler } from './selectSpecificLocationIndicatorDispatcherHandler';
import {
  handleSettingsAddLocations,
  handleSettingsLocationSelect,
  handleSettingsSelectAll,
} from '../../../components/store/slices/settings/force&CommandAndAdminSelectSlice';

const changeObjKeysHandler = (myObject) => {
  const updatedObject = {};

  const keyMap = {
    controller: 'switch',
    arr: 'arr',
  };
  for (const key in myObject) {
    if (key in keyMap) {
      updatedObject[keyMap[key]] = myObject[key];
    } else {
      updatedObject[key] = myObject[key];
    }
  }

  return updatedObject;
};

export const mainSelectIndicatorHandler = (propObj) => {
  const {
    dispatch,
    data,
    locations,
    swtName,
    specificLocations,
    isLocationSelected,
    isSpecificLocationSelected,
    isMachineSelected,
    isAllSelected,
    selectedSpecificLocations,
    selectedLocations,
    selectedMachines,
    option,
    machine,
    extraOption,
    machineIndex,
  } = propObj;

  const turnOffParents = (locationIdx) => {
    const locationArr = [...isLocationSelected];
    locationArr[locationIdx] = false;

    dispatch(handleSettingsSelectAll({ switch: swtName, status: false }));
    dispatch(
      handleSettingsLocationSelect({ switch: swtName, arr: locationArr }),
    );
    dispatch(
      handleSettingsAddLocations({
        switch: swtName,
        arr: selectedLocations.filter((el) => el !== locations[locationIdx]),
      }),
    );
  };

  if (option === 'all') {
    const { locationList, specificLocationList, machineList, select } =
      selectAllHandler(
        data,
        swtName,
        isLocationSelected,
        isSpecificLocationSelected,
        isAllSelected,
      );

    const modifiedList = [locationList, specificLocationList, machineList].map(
      (list) => changeObjKeysHandler(list),
    );

    selectAllIndicatorDispatcherHandler(
      dispatch,
      swtName,
      { newLocationList: modifiedList[0] },
      { newSpecificLocationList: modifiedList[1] },
      { newMachineList: modifiedList[2] },
      select,
    );
  } else if (option !== 'all' && machine === undefined) {

    const {
      locationList,
      specificLocationList,
      machineList,
      newSelectedLocations,
      select,
    } = selectSettingsLocationHandler(
      data,
      option,
      locations,
      isLocationSelected,
      isMachineSelected,
      selectedLocations,
    );

    if (!select) {
      dispatch(handleSettingsSelectAll({ switch: swtName, status: false }));
    }

    const uniqueLocationsArr = Array.from(
      new Set(newSelectedLocations.map(JSON.stringify)),
    ).map(JSON.parse);
    selectLocationIndicatorDispatcherHandler(
      dispatch,
      swtName,
      locationList,
      specificLocationList,
      machineList,
      uniqueLocationsArr,
    );
  } else if (option !== 'all' && machine === 'isSpecificLocation') {

    const {
      specificLocationList,
      machineList,
      newSpecificLocations,
      select,
      locationIndex,
    } = selectSettingsSpecificLocationHandler(
      data,
      option,
      machineIndex,
      extraOption,
      locations,
      isSpecificLocationSelected,
      isMachineSelected,
      specificLocations,
      selectedSpecificLocations,
    );

    if (!select) {
      turnOffParents(locationIndex);
    }

    const uniqueSpecificLocationsArr = Array.from(
      new Set(newSpecificLocations.map(JSON.stringify)),
    ).map(JSON.parse);

    selectSpecificLocationIndicatorDispatcherHandler(
      dispatch,
      swtName,
      specificLocationList,
      machineList,
      uniqueSpecificLocationsArr,
    );
  } else {
    const {
      locationIdx,
      specLocationIdx,
      machineIdx,
      newSelectedMachine,
      select,
    } = selectSettingsMachineHandler(
      option,
      machine,
      extraOption,
      data,
      selectedMachines,
      isMachineSelected,
    );

    if (!select) {
      turnOffParents(locationIdx);
    }

    const uniqueMachinesArr = Array.from(
      new Set(newSelectedMachine.map(JSON.stringify)),
    ).map(JSON.parse);

    selectMachineIndicatorDispatcherHandler(
      dispatch,
      swtName,
      locationIdx,
      specLocationIdx,
      machineIdx,
      uniqueMachinesArr,
      select,
    );
  }
};
